import { guardClient } from 'api/_axios'

/**
 * メモ更新
 * [Patch]/memo/{id}
 */
type MemoUpdateType = {
  companyId: number
  memo: string
  version: string
}
export const updateMemo = async (request: MemoUpdateType) => {
  const path = '/memo'

  const { companyId, ...params } = request
  const response = await guardClient.patch(path + '/' + companyId, params)
  return response.data
}
